import GraphQLService from './GraphQLService';

export default {
  async putPVTechnicalInspectionDocumentGraphQL(
    fileName,
    bucketName,
    encrypted
  ) {
    return GraphQLService.requestWithOpenID(
      `
        query uploadFileExtended($bucket: String, $key: String, $encrypted: Boolean){
          uploadFileExtended(bucket: $bucket, key: $key, encrypted: $encrypted) {
            url
            key
            uuid
          }
        }`,
      {
        bucket: bucketName,
        key: fileName,
        encrypted: Boolean(encrypted),
      }
    );
  },
  async resendDocument(
    type,
    id,
    recipients,
    additionalComment,
    filename,
    user
  ) {
    return GraphQLService.requestWithOpenID(
      `
        mutation resendFile($type: String!, $id: String!,$recipients: [String!]!, $additional_comment: String, $filename: String!, $changed_by: String!){
          resendFile(type: $type, id: $id,recipients: $recipients, additional_comment: $additional_comment, filename: $filename, event_origin: "BACKOFFICE", changed_by: $changed_by) {
            field
            id
            filename
            changed_by
            created
          }  
        }`,
      {
        type,
        id,
        recipients,
        additional_comment: additionalComment,
        filename,
        changed_by: user,
      }
    );
  },
  async getDocumentFromS3(fileName, bucketName) {
    return GraphQLService.requestWithOpenID(
      `
        query downloadFileS3 ($bucketName: String, $fileName: String) {
          downloadFile(bucket: $bucketName, key: $fileName)
        }`,
      {
        fileName: fileName,
        bucketName: bucketName,
      }
    );
  },
  async putDocumentToS3(fileName, bucketName, encrypted) {
    return GraphQLService.requestWithOpenID(
      `
        query uploadFileS3($bucketName: String, $fileName: String, $encrypted: Boolean) {
          uploadFile(bucket: $bucketName, key: $fileName, encrypted: $encrypted)
        }`,
      {
        encrypted: Boolean(encrypted),
        fileName: fileName,
        bucketName: bucketName,
      }
    );
  },
};
